<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="stocks"
    :search="search"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>AJUSTE DE ESTOQUE - APROVAÇÃO</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark to="/express/lancamento-estoque">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
        <v-dialog
          v-model="dialogApproved"
          min-width="1100px"
          max-width="1600px"
        >
          <v-card v-if="editedItem">
            <v-toolbar color="black lighten-1" dark class="text-h6"
              >Aprovar de Ajuste no Estoque</v-toolbar
            >
            <v-card-text class="pt-5" min-height="600px">
              <v-row class="">
                <v-col cols="12" xs="12" md="2">
                  <label class="font-weight-bold"
                    >Código: {{ formaterCode(editedItem.code) }}</label
                  >
                </v-col>
                <v-col cols="12" xs="12" md="5">
                  <label class="font-weight-bold"
                    >Fornecedor: {{ editedItem.provider.code }} -
                    {{ editedItem.provider.name }}</label
                  >
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <label class="font-weight-bold"
                    >Data: {{ editedItem.updated_at | datetimeFormatBr }}</label
                  >
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <label class="font-weight-bold d-flex justify-end"
                    >Total: {{ getTotalProducts(editedItem) }}</label
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    dense
                    sort-by="reference"
                    :headers="headers_products"
                    :items="editedItem.products"
                  >
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.color="{ item }">
                      {{ item.color.code }} - {{ item.color.name }}
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.material="{ item }">
                      {{ item.material.code }} - {{ item.material.name }}
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.reference="{ item }">
                      {{ editedItem.provider.code
                      }}{{ item.product.reference }} - {{ item.product.name }}
                    </template>
                    <template v-slot:item.grid="{ item }">
                      <table class="table-grid-cart">
                        <thead>
                          <tr>
                            <th
                              v-for="size in item.grid_quantity"
                              :key="`${size.size}`"
                              class="text-right"
                            >
                              {{ size.size }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              v-for="size in item.grid_quantity"
                              :key="`${size.size}`"
                              class="text-right"
                            >
                              {{ size.quantity }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black darken-1" text @click="closeApproved()"
                >Cancelar</v-btn
              >
              <v-btn color="red lighten-1" dark @click="canceledStock()"
                ><v-icon left dark>mdi-close</v-icon>Reprovar</v-btn
              >
              <v-btn color="green darken-1" dark @click="approvedStock()">
                <v-icon dark>mdi-check</v-icon>
                Aprovar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.provider="{ item }">
      {{ item.provider.code }} - {{ item.provider.name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.code="{ item }">
      {{ formaterCode(item.code) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.operation="{ item }">
      {{ getOperationText(item.operation) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.qty_products="{ item }">
      {{ item.products.length }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.total="{ item }">
      {{ getTotalProducts(item) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="green darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="green darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-file
          </v-icon>
        </template>
        <span>Validar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
// import * as API from "@/api/requests/CestRequest";
import { URL } from "@/api/config";
import { settings as settingsStock } from "@/helpers/settings_express_stock";

export default {
  data: () => ({
    dialogApproved: false,
    search: "",
    loading: false,
    headers: [
      { text: "Código", value: "code", width: 100 },
      { text: "Fornecedor", value: "provider", width: 200 },
      { text: "Operacação", value: "operation", width: 150 },
      { text: "Observação", value: "observation", width: 150 },
      {
        text: "Qtde. Produtos",
        value: "qty_products",
        width: 100,
        align: "right",
      },
      { text: "Qtde. Itens", value: "total", width: 100, align: "right" },
      { text: "Data", value: "updated_at", width: 200 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    headers_products: [
      { text: "Produto", value: "reference", width: 200 },
      { text: "Material", value: "material", width: 150 },
      { text: "Cor", value: "color", width: 150 },
      { text: "Grade", value: "grid", width: 340 },
      { text: "Total", value: "total", width: 80, align: "right" },
    ],
    stocks: [],
    editedItem: {
      provider: {},
      products: [],
    },
    defaultItem: {
      provider: {},
      products: [],
    },
  }),

  computed: {},

  watch: {
    dialogApproved(val) {
      val || this.closeApproved();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getExpressStocks();
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getExpressStocks() {
      this.loading = true;
      this.stocks = [];
      try {
        let res = await fetch(`${URL}express/stock`);
        if (res.status === 200) {
          let response = await await res.json();
          this.stocks = response;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.dialogApproved = true;
      this.editedItem = Object.assign({}, item);
      // this.$router.push({ name: "AdjustStock", params: { id: item.id } });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogApproved = false;
    },

    async deleteItemConfirm() {
      // this.loading = true;
      // this.cests = [];
      // try {
      //   await API.destroy(this.editedItem.id);
      //   this.loading = false;
      //   this.initialize();
      // } catch (error) {
      //   this.loading = false;
      //   console.log(error);
      // }
      // this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeApproved() {
      this.dialogApproved = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
    getOperationText(operation) {
      let index = settingsStock.findIndex((item) => item.id === operation);
      if (index > -1) {
        const setting = settingsStock[index];
        return setting.name;
      }
      return "";
    },
    getTotalProducts(item) {
      return item.products.reduce((a, b) => a + b.total, 0);
    },
    formaterCode(code) {
      if (code === undefined || code === null || code === "") {
        return "";
      }
      return code.toString().padStart(7, 0);
    },
    canceledStock() {
      console.log(this.editedItem);
      this.updateStock("canceled");
    },
    approvedStock() {
      console.log(this.editedItem);
      this.updateStock("approved");
    },
    async updateStock(status) {
      let status_text = status === "canceled" ? "Reprovado" : "Aprovado";
      let data = this.editedItem;
      data.status = status;
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}express/stock/update-status`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        console.log(await res.json());
        this.dialogApproved = false;
        if (res.status === 200) {
          alert(`Ajuste no estoque ${status_text} com sucesso`);
          this.getExpressStocks();
        } else {
          alert(
            `Houve um problema ao ${status_text} o ajuste, tente novamente mais tarde`
          );
        }
      } catch (error) {
        alert(
          `Houve um problema ao ${status_text} o ajuste, tente novamente mais tarde`
        );
        console.log(error);
      } finally {
        this.dialogApproved = false;
      }
    },
  },
};
</script>

<style scoped>
.table-grid-cart {
  border-collapse: collapse;
}

.table-grid-cart > thead > tr > th,
.table-grid-cart > tbody > tr > td {
  padding: 6px;
  border: 1px solid black;
}

.table-grid-cart > tbody > tr > td {
  background-color: white !important;
}
</style>
